function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import isSharedItem from 'swag-common/utils/order/is-item-shared.util';
import { isBox } from 'swag-common/utils/order/item-is-box.util';
import { isExistNonBoxReminderInCart, getCartItemsWithMergedItem } from '../../../customer/redux/box-builder/remove-box-items';
export let DIRECTIONS = /*#__PURE__*/function (DIRECTIONS) {
  DIRECTIONS["FROM_CART_TO_DRAFT"] = "FROM_CART_TO_DRAFT";
  DIRECTIONS["FROM_DRAFT_TO_CART"] = "FROM_DRAFT_TO_CART";
  return DIRECTIONS;
}({});
export const moveItemBetweenCartAndDraft = ({
  itemId,
  direction,
  cartItems,
  draftItems
}) => {
  //define where should appear new items
  const recipientItems = direction === DIRECTIONS.FROM_CART_TO_DRAFT ? cartItems : draftItems;
  const itemForMove = recipientItems.find(i => i._id === itemId);
  if (!itemForMove) {
    return {
      cartItems,
      draftItems
    };
  }
  const relatedItemsNotInBox = getRelatedItems({
    recipientItems,
    itemForMove,
    notInBox: true
  });

  //check if exist related then should be moved too
  if (relatedItemsNotInBox.length > 1) {
    return {
      cartItems: getNewCartItemsAfterRelatedMoving({
        cartItems,
        itemsForMove: relatedItemsNotInBox,
        direction
      }),
      draftItems: getNewDraftItemsAfterRelatedMoving({
        draftItems,
        itemsForMove: relatedItemsNotInBox,
        direction
      })
    };
  }

  //check is itemId it's box item itself id
  const isBoxItemItself = isBox(itemForMove);
  if (isBoxItemItself) {
    const itemsForMove = recipientItems.filter(i => i.boxItemsId === itemForMove.boxItemsId);
    return {
      cartItems: getNewCartItemsAfterBoxMoving({
        cartItems,
        itemsForMove,
        direction
      }),
      draftItems: getNewDraftItemsAfterBoxMoving({
        draftItems,
        itemsForMove,
        direction
      })
    };
  } else {
    return {
      cartItems: getNewCartItemsAfterStandaloneMoving({
        cartItems,
        itemForMove,
        direction
      }),
      draftItems: getNewDraftItemsAfterStandaloneMoving({
        draftItems,
        itemForMove,
        direction
      })
    };
  }
};

//helpers-----------------

const getNewCartItemsAfterBoxMoving = ({
  cartItems,
  itemsForMove,
  direction
}) => {
  if (direction === DIRECTIONS.FROM_CART_TO_DRAFT) {
    return getItemsWithCorrectBlendedQuantity(cartItems.filter(item => !itemsForMove.find(ifm => ifm._id === item._id)));
  } else {
    return getItemsWithCorrectBlendedQuantity([...cartItems, ...itemsForMove]);
  }
};
const getNewCartItemsAfterStandaloneMoving = ({
  cartItems,
  itemForMove,
  direction
}) => {
  if (direction === DIRECTIONS.FROM_CART_TO_DRAFT) {
    return getItemsWithCorrectBlendedQuantity(cartItems.filter(item => item._id !== itemForMove._id));
  } else {
    if (isExistNonBoxReminderInCart({
      cartItems,
      cartItem: itemForMove
    })) {
      return getItemsWithCorrectBlendedQuantity(getCartItemsWithMergedItem({
        alreadyCheckedItems: cartItems,
        cartItems,
        cartItem: itemForMove
      }));
    } else {
      return getItemsWithCorrectBlendedQuantity([...cartItems, itemForMove]);
    }
  }
};
const getNewCartItemsAfterRelatedMoving = ({
  cartItems,
  itemsForMove,
  direction
}) => {
  if (direction === DIRECTIONS.FROM_CART_TO_DRAFT) {
    return getItemsWithCorrectBlendedQuantity(cartItems.filter(item => !itemsForMove.find(ifm => ifm._id === item._id)));
  } else {
    return getItemsWithCorrectBlendedQuantity([...cartItems, ...itemsForMove]);
  }
};
const getNewDraftItemsAfterBoxMoving = ({
  draftItems,
  itemsForMove,
  direction
}) => {
  if (direction === DIRECTIONS.FROM_CART_TO_DRAFT) {
    return getItemsWithCorrectBlendedQuantity([...draftItems, ...itemsForMove]);
  } else {
    return getItemsWithCorrectBlendedQuantity(draftItems.filter(item => !itemsForMove.find(ifm => ifm._id === item._id)));
  }
};
const getNewDraftItemsAfterStandaloneMoving = ({
  draftItems,
  itemForMove,
  direction
}) => {
  if (direction === DIRECTIONS.FROM_CART_TO_DRAFT) {
    if (isExistNonBoxReminderInCart({
      cartItems: draftItems,
      cartItem: itemForMove
    })) {
      return getItemsWithCorrectBlendedQuantity(getCartItemsWithMergedItem({
        alreadyCheckedItems: draftItems,
        cartItems: draftItems,
        cartItem: itemForMove
      }));
    } else {
      return getItemsWithCorrectBlendedQuantity([...draftItems, itemForMove]);
    }
  } else {
    return getItemsWithCorrectBlendedQuantity(draftItems.filter(item => item._id !== itemForMove._id));
  }
};
const getNewDraftItemsAfterRelatedMoving = ({
  draftItems,
  itemsForMove,
  direction
}) => {
  if (direction === DIRECTIONS.FROM_CART_TO_DRAFT) {
    return getItemsWithCorrectBlendedQuantity([...draftItems, ...itemsForMove]);
  } else {
    return getItemsWithCorrectBlendedQuantity(draftItems.filter(item => !itemsForMove.find(ifm => ifm._id === item._id)));
  }
};
const getRelatedItems = ({
  recipientItems,
  itemForMove,
  notInBox
}) => {
  if (!itemForMove.asRelatedItemId) {
    return [];
  }
  return recipientItems.filter(i => i.asRelatedItemId === itemForMove.asRelatedItemId && (notInBox ? !i.boxItemsId : true));
};
export const getItemsWithCorrectBlendedQuantity = items => items.map(item => _objectSpread({}, item, {
  blendedQuantity: getNewBlendedQuantity(item, items)
}));
const getNewBlendedQuantity = (item, items) => {
  const relatedItems = getRelatedItems({
    recipientItems: items,
    itemForMove: item
  });
  if (relatedItems.length > 1) {
    return relatedItems.reduce((acc, i) => acc + i.quantity, 0);
  }
  const sharedItems = items.filter(i => isSharedItem(i, [item]));
  return item.quantity + sharedItems.reduce((acc, i) => acc + i.quantity, 0);
};